import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrButton } from "../buttons";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import { Dialog } from "@mui/material";
import classNames from "classnames";
const StyledTitle = styled("span")(({ size }) => ({
    color: palette.grey080,
    ...typography[size === "mobile" ? "Content.Title02" : "Content.Title01"],
}));
// eslint-disable-next-line no-empty-pattern
const StyledChildrenWrapper = styled("div")(({ size }) => ({
    scrollbarWidth: "thin",
    padding: "0 24px",
    position: "relative",
    ...typography[size === "mobile" || size === "xs" ? "Content.Body03" : "Content.Subtitle03"],
    color: palette.grey070,
    wordBreak: "break-all",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
        width: "8px",
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
        padding: "0 2px",
    },
    "&::-webkit-scrollbar-thumb": {
        width: "8px",
        borderRadius: "6px",
        scrollPadding: "0 2px",
        backgroundColor: palette.grey030,
        backgroundClip: "padding-box",
    },
}));
export function GrDialog({ title, size = "small", role = "dialog", titleIcon, onConfirm, onClose, header, children, footer, preventCloseOnOutsideClick = false, confirmButton, cancelButton, isLoading, scroll, className, ...props }) {
    var _a, _b;
    return (_jsxs(Dialog, { role: role, "data-testid": role, className: classNames("GrDialog", className), scroll: scroll, sx: {
            "& .MuiDialog-paper": {
                width: (size === "mobile" && "320px") ||
                    (size === "xs" && "440px") ||
                    (size === "small" && "600px") ||
                    (size === "medium" && "900px") ||
                    (size === "large" && "1200px") ||
                    (size === "xl" && "1536px") ||
                    "320px",
                margin: "0 !important",
                padding: "24px 0",
                borderRadius: "8px",
                maxHeight: "calc(100vh - 80px)",
            },
            ".MuiBackdrop-root": {
                backgroundColor: palette.dimmed030,
            },
        }, maxWidth: "xl", onClose: () => !preventCloseOnOutsideClick && onClose(), ...props, children: [_jsxs(GrStack, { flexDirection: "column", padding: "0 24px", margin: "0 0 18px 0", children: [(!!title || !!titleIcon) && (_jsxs(GrStack, { gap: "8px", children: [!!titleIcon && titleIcon, _jsx(StyledTitle, { size: size, children: title })] })), _jsx("div", { children: header })] }), _jsx(StyledChildrenWrapper, { size: size, children: children }), _jsxs(GrStack, { margin: "30px 0 0 0", padding: "0 24px", justifyContent: "space-between", alignItems: "end", children: [_jsx("div", { children: footer }), _jsxs(GrStack, { gap: "10px", children: [!!cancelButton && (_jsx(GrButton, { role: "cancel-button", "data-testid": "cancel-button", size: "medium", onClick: onClose, style: { minWidth: "80px" }, variant: "contained", color: "grey", ...cancelButton, children: (_a = cancelButton === null || cancelButton === void 0 ? void 0 : cancelButton.children) !== null && _a !== void 0 ? _a : "취소" })), !!onConfirm && (_jsx(GrButton, { role: "confirm-button", "data-testid": "confirm-button", size: "medium", isLoading: isLoading, onClick: onConfirm, style: { minWidth: "80px" }, variant: "contained", color: "primary", ...confirmButton, children: (_b = confirmButton === null || confirmButton === void 0 ? void 0 : confirmButton.children) !== null && _b !== void 0 ? _b : "확인" }))] })] })] }));
}
//# sourceMappingURL=GrDialog.js.map